var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module_title"},[_c('span',{staticClass:"home_about_title"},[_c('span',{staticClass:"home_about_title1"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }